import React, { createContext, useState, useCallback } from 'react';

export const SUPPORTED_TIMEZONES = ['America/Mexico_City', 'Europe/Madrid'];

const STORAGE_KEY = 'mirtomex.timezone';

const detectDefaultTimezone = () => {
  const stored = window.localStorage.getItem(STORAGE_KEY);
  if (stored && SUPPORTED_TIMEZONES.includes(stored)) return stored;

  try {
    const browserTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (SUPPORTED_TIMEZONES.includes(browserTz)) return browserTz;
  } catch (e) {
    // Intl no disponible: fallback silencioso
  }

  return 'America/Mexico_City';
};

export const TimezoneContext = createContext();

export const TimezoneProvider = ({ children }) => {
  const [timezone, setTimezone] = useState(detectDefaultTimezone);

  const changeTimezone = useCallback((tz) => {
    if (!SUPPORTED_TIMEZONES.includes(tz)) return;
    window.localStorage.setItem(STORAGE_KEY, tz);
    setTimezone(tz);
  }, []);

  return <TimezoneContext.Provider value={{ timezone, changeTimezone }}>{children}</TimezoneContext.Provider>;
};
